export default "/images/exclaimation.png?dc1d02fa62e9acac4a1c15f5b162e848";